import index from './index.vue'

const QRcode = {
  install: function (Vue) {
    Vue.component('QRcode', index)
  }
}

export default QRcode
